module.exports = __webpack_public_path__ + "static/media/zameen-opal-v1.3851bc14.jpg";